import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-title" }, "Release lots", -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(`The status of ${$setup.plural($props.listForUpdate.length, "this")} ${$setup.plural($props.listForUpdate.length, "lot", false)} will be set to 'Available'. New potential buyers will be able to submit Contract information forms for ${$setup.plural($props.listForUpdate.length, "this")} ${$setup.plural($props.listForUpdate.length, "lot", false)}.`), 1),
        _createVNode($setup["CheckboxInput"], {
          label: "Notify waitlist",
          modelValue: $setup.notifyWaitlist,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.notifyWaitlist = !$setup.notifyWaitlist))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "button default cancel",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.close(false)))
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary release",
            onClick: $setup.release
          }, "Release")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}